import React, { useEffect, useState } from 'react'
import { dataNoFuso, erroDeRecuperacao, mensagemDeErro, recuperacaoInicial } from '../../libs/hipersync'

export default function ConfirmarAtivacao({ integracao, servico, api, secret, ocupado, onVoltar, onConfirmar }) {
  const [recuperacao, setRecuperacao] = useState(() => recuperacaoInicial(integracao.config?.recuperacao))
  const [consulta, setConsulta] = useState(null)
  const [erro, setErro] = useState('')
  const [carregando, setCarregando] = useState(true)
  const [tentativa, setTentativa] = useState(0)
  const erroLimite = erroDeRecuperacao(recuperacao)
  const data = dataNoFuso(integracao.config?.fuso)
  const maxDiasAtraso = recuperacao.maxDiasAtraso
  const contagemAtual = consulta?.limite === maxDiasAtraso && !carregando
  useEffect(() => {
    let atual = true
    setConsulta(null); setErro(''); setCarregando(!erroLimite)
    if (erroLimite) return
    // Espera a digitação terminar antes de consultar novamente o sistema.
    const timer = setTimeout(async () => {
      try {
        const resposta = await servico.ensaio(api, secret, data, maxDiasAtraso)
        if (!Number.isSafeInteger(resposta?.anterioresEmAberto) || resposta.anterioresEmAberto < 0) throw new Error('Contagem não confirmada')
        if (atual) setConsulta({ total: resposta.anterioresEmAberto, limite: maxDiasAtraso })
      } catch (falha) { if (atual) setErro(mensagemDeErro(falha)) }
      finally { if (atual) setCarregando(false) }
    }, 300)
    return () => { atual = false; clearTimeout(timer) }
  }, [servico, api, secret, data, maxDiasAtraso, erroLimite, tentativa])
  return <form className="hs-confirmacao-recuperacao" aria-label="Confirmação para ligar o Piloto" onSubmit={e => {
    e.preventDefault()
    if (!ocupado && contagemAtual && !erroLimite && !erro) onConfirmar(recuperacao)
  }}>
    <h3>Ligar o Piloto com as rotinas revisadas?</h3>
    {carregando && <p role="status">Consultando as cobranças em aberto…</p>}
    {contagemAtual && <p className="hs-contagem-recuperacao">Há {consulta.total} {consulta.total === 1 ? 'cobrança em aberto' : 'cobranças em aberto'} no sistema.</p>}
    <fieldset disabled={ocupado}>
      <legend>Quais cobranças acompanhar</legend>
      <div className="hs-escolhas-recuperacao">
        <label><input type="radio" name="recuperacao-ativacao" checked={recuperacao.ativa} onChange={() => setRecuperacao(r => ({ ...r, ativa: true }))} />Avisar também as cobranças que já estavam em aberto</label>
        <label className="hs-limite-recuperacao">— vencidas há no máximo <input className="dp-campo hs-dias" type="number" aria-label="Limite de atraso para recuperar" min="1" max="365" step="1" required aria-invalid={!!erroLimite} aria-describedby={erroLimite ? 'erro-limite-recuperacao' : undefined} value={maxDiasAtraso} onChange={e => setRecuperacao(r => ({ ...r, maxDiasAtraso: e.target.value === '' ? '' : Number(e.target.value) }))} /> dias.</label>
        <label><input type="radio" name="recuperacao-ativacao" checked={!recuperacao.ativa} onChange={() => setRecuperacao(r => ({ ...r, ativa: false }))} />Começar só com as novas</label>
      </div>
    </fieldset>
    {recuperacao.ativa && <p className="hs-avisos">Antes de ligar com recuperação, dê baixa nos comprovantes já recebidos.</p>}
    {erroLimite && <p className="dp-erro" role="alert" id="erro-limite-recuperacao">{erroLimite}</p>}
    {erro && <div><p className="dp-erro" role="alert">{erro}</p><button className="dp-btn" type="button" onClick={() => setTentativa(t => t + 1)}>Consultar novamente</button></div>}
    <div className="hs-acoes"><button className="dp-btn" type="button" disabled={ocupado} onClick={onVoltar}>Voltar</button><button className="dp-btn pri" type="submit" disabled={ocupado || !contagemAtual || !!erroLimite || !!erro}>{ocupado ? 'Salvando…' : 'Confirmar ativação'}</button></div>
  </form>
}
